/* eslint-disable camelcase */
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Auth } from 'aws-amplify';

import FormValidator from '../formValidator';

const useUserProfile = () => {
  const dispatch = useDispatch();
  const formValidator = FormValidator();
  const customerId = useSelector((state) => state.accounts.user.id);
  useEffect(() => {
    async function fetchProfile() {
      try {
        const session = await Auth.currentCredentials();
        if (session.authenticated === true) {
          await Auth.currentSession();
          const user = await Auth.currentAuthenticatedUser({
            bypassCache: true,
          });
          const {
            given_name, family_name, email, phone_number, 'custom:email_to_be_updated': email_to_be_updated,
          } = user.attributes;
          if (given_name) {
            const profile = {
              given_name,
              family_name,
              phone_number: phone_number && phone_number.replace('+1', ''),
              email,
              'custom:email_to_be_updated': email_to_be_updated,
            };
            await dispatch({ type: 'accounts/setUserProfile', payload: profile });
            await dispatch({
              type: 'accounts/setUserID',
              payload: user.signInUserSession.idToken.payload.customerId,
            });
          }
        } else {
          dispatch({ type: 'accounts/setCustomerId', payload: null });
          Auth.signOut();
          localStorage.clear();
        }
      } catch (error) {
        formValidator.errorHandling(error);
        if (!error.message?.includes('order history')) {
          Auth.signOut();
          localStorage.clear();
          dispatch({ type: 'accounts/setCustomerId', payload: null });
        }
      }
    }
    fetchProfile();
  }, [customerId, dispatch, formValidator]);
};

export default useUserProfile;
